export default function useIsAuthenticated() {
  // return true;

  return process.env.REACT_APP_DISABLE_AUTH !== "true";
}
